<template>
  <div class="content-box">
    <div class="single-page-container">
      <div class="col-sm-6 col-md-3 pl-0 pr-0 middle">
        <div class="pricing-plans row no-gutters" style="height: 100%;">
          <div class="pricing-plan col-sm-12">
            <div class="plan-body">
              <div class="row m-b">
                <div class="col-sm-6 b-r b-b">
                  <div class="el-tablo centered padded-v">
                    <div class="value">
                      <div class="list-order">
                        <select
                          v-model="selectedChannel"
                          class="form-control form-control-sm rounded inline-block"
                        >
                          <option
                            v-for="channel in channels"
                            :value="channel.id_channel"
                          >{{channel.channel_name}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="label">channel</div>
                  </div>
                </div>
                <div class="col-sm-6 b-b">
                  <div class="el-tablo centered padded-v">
                    <ul class="nav nav-pills smaller d-none d-lg-flex centered">
                      <li class="nav-item">
                        <a class="nav-link active" data-toggle="tab" href="#" @click="mode = 'Check In'">Check In</a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" data-toggle="tab" href="#" @click="mode = 'Check Out'">Check Out</a>
                      </li>
                    </ul>
                    <br>
                        {{ mode == 'Check In' ? 'to ' : 'from ' }}<span class="text-bold">{{defaultLocation.name_en}}</span>

                    <!-- <div class="value text-capitalize">Checkout</div> -->
                    <!-- <div class="label">Mode</div> -->
                  </div>
                </div>
              </div>
              <div class="chat-head p-10">
                <div class="user-info">
                    <ul class="nav nav-pills smaller d-none d-lg-flex centered pb-3">
                      <li class="nav-item">
                        <a class="nav-link active" data-toggle="tab" href="#" @click="importmode = 'single'">Single</a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" data-toggle="tab" href="#" @click="importmode = 'bulk'">Bulk</a>
                      </li>
                    </ul>
                  <span class="element-wrapper">
                    
                    <div class="element-search" v-if="importmode == 'single'">
                      <input
                        :placeholder="mode + ' product'"
                        type="text"
                        v-on:keyup.enter="registerUpdate"
                        v-model="searchString"
                      />
                    </div>
                    <div class="" v-if="importmode == 'bulk'">
                      <textarea
                      class="form-control" rows="20"
                        :placeholder="mode + ' products in bulk'"
                        type="text"
                        v-on:keyup.enter="registerUpdate"
                        v-model="searchString"
                      />
                    </div>                    
                  </span>
                </div>
              </div>
              <div class="element-wrapper p-10 scrollable" v-if="importmode == 'single'">
                <h6 class="element-header">Product Movement</h6>
                <div class="element-box-tp">
                  <div class="activity-boxes-w" v-for="history in productHistory">
                    <div class="activity-box-w">
                      <div class="activity-time">{{history.location}}</div>
                      <div class="activity-box">
                            <span class="stacked"><i class="fa fa-arrow-right"></i> {{history.inbound_at}} </span>
                            <span class="stacked"><i class="fa fa-arrow-left"></i> {{history.outbound_at}} </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-9 middle">
        <ProductInventory :selectedChannel="selectedChannel" :updateKey="updateKey"/>
        <!-- <div class="support-index">
          <div class="support-tickets"></div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import EmptyState from '@/components/common/EmptyState'
import Loader from '@/components/common/EmptyState'
import SessionTabs from '@/components/common/SessionView/SessionTabs'

import ProductInventory from '@/components/productdesk/ProductInventory'

export default {
  components: {
    EmptyState,
    Loader,
    SessionTabs,
    ProductInventory
  },
  data () {
    return {
      updateKey: 0,
      channels: '',
      selectedChannel: '',
      searchString: '',
      mode: 'Check In',
      importmode: 'single',
      locations: ['studio', 'prepped', 'copy'],
      selectedLocation: 'studio',
      productHistory: [],
      tabOptions: [
        {
          name: 'Check In',
          icon: 'fal fa-inbox-in'
        },
        {
          name: 'Check Out',
          icon: 'fal fa-inbox-out'
        }
      ],
      selectedTab: 'Check In'
    }
  },
  mounted () {
    this.getParams()
  },
  methods: {
    getParams () {
      var self = this

      this.channels = this.$store.getters.clientChannels
      this.selectedChannel = this.channels[0].id_channel
    },
    registerUpdate () {
      if (this.mode == 'Check In') {
        this.checkinProduct()
      } else {
        this.checkoutProduct()
      }
    },
    checkinProduct () {
      var self = this

      const url = self.importmode == 'bulk' ? '/productdesk/inventory/checkin/bulk' : '/productdesk/inventory/checkin'
      let data = {
        id_channel: self.selectedChannel,
        identifier: self.searchString,
        location: self.selectedLocation
      }

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.productHistory = response.data.history
          if (response.data && response.data.error) {
            self.$store.dispatch('updateToast', {
              text: response.data.error,
              show: true
            })
          } else {
            self.$store.dispatch('updateToast', {
              text: 'Product checked in successfully',
              show: true
            })
          }
          self.updateKey++
          self.searchString = ''
        })
        .catch(function (error) {
          console.log(error.response.data.error)
          var audio = new Audio('/sound/error.mp3'); // path to file
          audio.play();
          self.$swal({
            toast: true,
            showConfirmButton: false,
            timer: 4000,
            icon: 'error',
            title: 'Error',
            text: error.response.data.error || 'Error checking in product',
          });
          self.$store.dispatch('updateToast', {
            text: error.response.data.error || 'Error checking in product',
            show: true
          })
          self.searchString = ''

        })
    },
    checkoutProduct () {
      var self = this

      const url = self.importmode == 'bulk' ? '/productdesk/inventory/checkout/bulk' : '/productdesk/inventory/checkout'
      let data = {
        id_channel: self.selectedChannel,
        identifier: self.searchString
      }

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.productHistory = response.data.history
          if (response.data && response.data.error) {
            self.$store.dispatch('updateToast', {
              text: response.data.error,
              show: true
            })
          } else {
            self.$store.dispatch('updateToast', {
              text: 'Product checked out successfully',
              show: true
            })
          }
          self.updateKey++
          self.searchString = ''
        })
        .catch(function (error) {
          console.log(error.response.data.error)
          self.$store.dispatch('updateToast', {
            text: error.response.data.error || 'Error checking out product',
            show: true
          })
          self.searchString = ''
        })
    },
    switchTab (tab) {
      this.selectedTab = tab
    }
  },
  computed: {
    defaultLocation () {
	  	var locations = this.$store.getters.clientLocations
      if(typeof(locations) == 'object') {
        let location = locations.find(loc => loc.is_default === 1)
        return location
      }
      return {}
	  }
  }
}
</script>

<style scoped>
.ae-side-menu {
  height: calc(100vh - 54px);
}
.app-email-i {
  height: calc(100vh - 54px);
  flex: 1;
}
.ae-side-menu {
  flex: 0 0 200px;
}
.stacked {
  display: block;
}
</style>
